import React, { useState } from "react";
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  Col,
  DatePicker,
  Collapse,
  Checkbox,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import data from "../../../../../src/config/data/LoanProductFormData.json";

const { Text } = Typography;

export const DetailsForm = (props) => {
  const { fixedDepositDetails } = props;

  return (
    <>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Product Name</Text>}>
              <Input className="of-bold-disable-input" disabled value={fixedDepositDetails?.name} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Short Name</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={fixedDepositDetails?.shortName}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Description</Text>}>
              <TextArea
                className="of-bold-disable-input"
                disabled
                value={fixedDepositDetails?.description}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Status</Text>}>
              <Input.TextArea
                className="of-bold-disable-input"
                disabled
                value={fixedDepositDetails?.active ? "Active" : "Inactive"}
              ></Input.TextArea>
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </>
  );
};
